import { Flex, Heading, Text } from "@chakra-ui/react"

type DepositModalReceiptElementProps = {
  label: string
  value: string
}

export default function DepositModalReceiptElement({
  label,
  value,
}: DepositModalReceiptElementProps) {
  return (
    <Flex w="100%" justifyContent="space-between" alignItems="center" mb={4}>
      <Text
        variant="body"
        fontWeight={500}
        fontFamily="riforma.medium"
        color="primary.black.70"
      >
        {label}
      </Text>
      <Heading
        variant="h4"
        textAlign="right"
        fontWeight={500}
        fontFamily="riforma.medium"
        color="primary.black.80"
      >
        {value}
      </Heading>
    </Flex>
  )
}
